package io.horion.cv.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.ViewButtonStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import kotlinx.coroutines.delay
//import org.jetbrains.compose.web.css.Cursor
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

@Composable
fun MissingFieldsPopup(
    missingFields: List<String>,
    onDismiss: () -> Unit
) {
    LaunchedEffect(Unit) {
        delay(4000)
        onDismiss()
    }
    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .styleModifier {
                property("top", "0")
                property("left", "0")
                property("width", "100vw")
                property("height", "100vh")
                property("background", "rgba(0,0,0,0.55)")
//                property("backdrop-filter", "blur(4px)")
//                property("-webkit-backdrop-filter", "blur(4px)")
                property("z-index", "1000")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("animation", "fadeIn 0.2s ease-out")
            }
            .onClick { onDismiss() }
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(14.px)
                .minWidth(280.px)
                .maxWidth(360.px)
                .padding(28.px)
                .boxShadow(
                    offsetX = 0.px,
                    offsetY = 10.px,
                    blurRadius = 30.px,
                    spreadRadius = 0.px,
                    color = rgba(0, 0, 0, 0.35)
                )
                .styleModifier {
                    property("animation", "popUp 0.25s cubic-bezier(0.34,1.56,0.64,1)")
                }
                .onClick { event -> event.stopPropagation() }
        ) {
            // Icône + titre
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(10.px),
                modifier = Modifier.fillMaxWidth()
            ) {
                Box(
                    modifier = Modifier
                        .width(32.px)
                        .height(32.px)
                        .borderRadius(50.percent)
                        .backgroundColor(rgba(239, 68, 68, 0.12))
                        .styleModifier {
                            property("display", "flex")
                            property("align-items", "center")
                            property("justify-content", "center")
                            property("flex-shrink", "0")
                        }
                ) {
                    SpanText(
                        "⚠",
                        modifier = Modifier
                            .fontSize(16.px)
//                            .color(Colors.Warning)
                    )
                }
                SpanText(
                    "Champs obligatoires manquants",
                    modifier = Modifier
                        .fontFamily(INTER)
                        .fontSize(16.px)
                        .fontWeight(FontWeight.SemiBold)
                        .color(Colors.Primary)
                )
            }

            Box(Modifier.height(14.px))

            SpanText(
                "Merci de remplir les champs suivants avant de continuer :",
                modifier = Modifier
                    .fontFamily(INTER)
                    .fontSize(13.px)
                    .color(Colors.Placeholder)
                    .styleModifier { property("line-height", "1.5") }
            )

            Box(Modifier.height(10.px))

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .backgroundColor(rgba(239, 68, 68, 0.06))
                    .borderRadius(8.px)
                    .padding(topBottom = 10.px, leftRight = 14.px)
            ) {
                missingFields.forEachIndexed { index, field ->
                    if (index > 0) Box(Modifier.height(6.px))
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(8.px)
                    ) {
                        SpanText(
                            "•",
                            modifier = Modifier
                                .fontSize(13.px)
                                .color(Colors.Warning)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            field,
                            modifier = Modifier
                                .fontFamily(INTER)
                                .fontSize(13.px)
                                .color(Colors.Warning)
                        )
                    }
                }
            }

            Box(Modifier.height(22.px))

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.End
            ) {
                Button(
                    onClick = { onDismiss() },
                    modifier = ViewButtonStyle.toModifier()
                        .borderRadius(7.px)
                        .padding(topBottom = 8.px, leftRight = 22.px)
                        .fontSize(14.px)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Normal)
                        .cursor(Cursor.Pointer)
                ) {
                    SpanText("Compris")
                }
            }
        }
    }
}